// components/course/LessonItem.js
import {
    hasPreviewContent,
    getLessonIcon,
    getLessonIconColor,
    formatDuration
} from '../utils/courseUtils';
import "../css/LessonItem.css";

function LessonItem({ lesson, onPlayPreviewVideo }) {
    return (
        <div className={`cur-less-sec-list-item ${hasPreviewContent(lesson) ? 'cur-less-sec-list-preview-available' : ''}`}>

            {/* TOP ROW — order number · title */}
            <div className="cur-less-sec-list-top-row">
                <div className="cur-less-sec-list-order">{lesson.order + 1}</div>

                <div className="cur-less-sec-list-title" title={lesson.title}>
                    {lesson.title}
                </div>
            </div>

      {/* BOTTOM ROW — icon · type · duration · actions */}
        <div className="cur-less-sec-list-bottom-row">

            <span
                className="cur-less-sec-list-icon"
                style={{ color: getLessonIconColor(lesson.lesson_type) }}
            >
                <i className={getLessonIcon(lesson.lesson_type)}></i>
            </span>

            <span className="cur-less-sec-list-type">{lesson.lesson_type}</span>

            {lesson.video_duration > 0 && (
                <span className="cur-less-sec-list-duration">
                    {formatDuration(lesson.video_duration)}
                </span>
            )}

            <span className="cur-less-sec-list-actions">
                {hasPreviewContent(lesson) ? (
                    <span
                        className="cur-less-sec-list-preview-badge cur-less-sec-list-clickable"
                        onClick={(e) => {
                            e.stopPropagation();
                            onPlayPreviewVideo(lesson);
                        }}
                    >
                        <i className="fas fa-eye"></i>
                        <span className="cur-less-sec-list-preview-label">Preview</span>
                    </span>
                ) : (
                    <span className="cur-less-sec-list-locked-badge" aria-label="Locked">
                        <i className="fas fa-lock"></i>
                    </span>
                )}
            </span>

        </div>
        </div>
    );
}

export default LessonItem;